<template>
  <z-form ref="form" tag="div" @submit.native.prevent="submit">
    <form class="row">
      <z-form-input class="col-8" :rules="{ required: true, max: 32 }">
        <digits-input v-model="number" />
      </z-form-input>
      <div class="col-4">
        <i-button type="primary" html-type="submit" :long="true" :loading="is_loading">
          {{ $t('shared.component.button.add') }}
        </i-button>
      </div>
    </form>
  </z-form>
</template>

<script>
  import DigitsInput from '@shared/components/input/input-digit-only';
  import { ContactExternalNumber } from '@pbx/services/ContactExternalNumberService';

  export default {
    components: { DigitsInput },
    data() {
      return {
        number: '',
        is_loading: false
      };
    },

    methods: {
      submit: function() {
        this.$refs.form.validate().then(is_valid => {
          if (is_valid) {
            this.is_loading = true;
            ContactExternalNumber.createItem({ number: this.number })
              .then(contact_method => {
                this.$emit('on-add', {
                  ...contact_method,
                  format_number: contact_method.number,
                  contact_external_number_id: contact_method.id
                });
                this.number = '';
                this.$refs.form.reset();
              })
              .catch(e => this.$noty.server_error(e))
              .finally(() => (this.is_loading = false));
          }
        });
      }
    }
  };
</script>
